<template>
  <article>
    <div>
      <Row>
        <Col span="3" style="lineHeight:33px">
          查看入住单
        </Col>
        <Col span="20">
          <Select v-model="currentCheckinId" @on-change="changeCheckOrder">
            <Option v-for="item in checkIds" :key="item.checkinId" :value="item.checkinId">
              入住单：{{ item.checkinId }} | 入住状态：{{ ["", "未入住", "已入住", "已退房"][item.step] }} |
              订单状态：{{ ["", "正常", "已取消", "已取消", "已换房"][reasionCheck(item.cancelReasion) ? 4 : item.stat] }} |
              房间：{{ item.roomName }}
            </Option>
          </Select>
        </Col>
      </Row><br>
      <Row>
        <Col span="3">
          <div>
            <span class="bold">房间ID：</span>{{ checkins.roomId }}
          </div>
        </Col>
        <Col span="3">
          <div>
            <span class="bold">房型：</span>{{ checkins.roomTypeName }}
          </div>
        </Col>
        <Col span="8">
          <div>
            <span class="bold">房号：</span>{{ checkins.roomNo }}
          </div>
        </Col>
        <Col span="8">
          <div>
            <span class="bold">房名：</span>{{ checkins.roomName }}
          </div>
        </Col>
        <Col span="3" v-if="(checkins.stat == 1 && checkins.step == 2 && checkins.verify == false)">入住单需要验证</Col>
      </Row><br>
      <Row>
        <Col span="6">
          <div>
            <span class="bold">门店负责人：</span>{{ checkins.roomBuildingInfo.chainManager }}
          </div>
        </Col>
        <Col span="8">
          <div>
            <span class="bold">门店：</span>{{ checkins.roomBuildingInfo.chainName }}
          </div>
        </Col>
        <Col span="8">
          <div>
            <span class="bold">是否支持外籍：</span>{{ ['不支持', '支持'][checkins.roomBuildingInfo.foreignStatus] }}
          </div>
        </Col>
      </Row><br>
      <Row>
        <Col span="6">
          <div>
            <span class="bold">楼层：</span>{{ checkins.roomBuildingInfo.roomFloor }}
          </div>
        </Col>
        <Col span="8">
          <div>
            <span class="bold">楼宇：</span>{{ checkins.roomBuildingInfo.name }}
          </div>
        </Col>
        <Col span="10">
          <div>
            <span class="bold">展示地址：</span>{{ checkins.roomBuildingInfo.address }}
          </div>
        </Col>
      </Row><br>
      <Row>
        <Col span="6">
          <div>
            <span class="bold">有无门锁：</span>{{ checkins.hasLock ? '有' : '无' }}
          </div>
        </Col>
        <Col span="8">
          <div>
            <span class="bold">服务项目：</span>{{ checkins.contractInfo ? checkins.contractInfo.serviceItems ?
            checkins.contractInfo.serviceItems : '-' : '-' }}
          </div>
        </Col>
      </Row><br>
      <Row>
        <Col>
          <Icon type="md-menu"></Icon>预计入住：{{ checkins.checkinTime }} -- 预计退房：{{ checkins.checkoutTime }}
          
        </Col>
      </Row><br>
      <Row v-show="checkins.hasDelayCheckout">
        <Col>
          <Icon type="md-menu"></Icon>延时退房申请时间：{{ checkins.delayAppleTime }} -- 申请人：{{ checkins.delayName }} -- 延迟退房时间：{{
            checkins.delayCheckoutTime }}
        </Col>
      </Row><br>
      <Row>
        <Col>
          <Button type="warning" @click="childList = !childList">查看子入住单</Button>
        </Col>
      </Row><br>
      <div v-if="childList">
        <Row v-for="(item, index) in checkins.infos" :key="index" style="margin-bottom:15px">
          {{ index + 1 }}&nbsp;{{ ['', '入住', '续住'][item.overstay] }} {{ item.checkinTime }} ~ {{ item.checkoutTime }}
          <strong v-if="item.payStat == 1 && item.stat == 1">等待支付</strong>
          <strong v-if="item.stat == 2 && !reasionCheck(checkins.cancelReasion)">已取消</strong>
          <strong v-if="item.stat == 2 && reasionCheck(checkins.cancelReasion)">已换房</strong>
          <strong v-if="item.checkin == 1 && item.stat == 1">未开始</strong>
          <strong v-if="item.checkin == 2 && item.stat == 1">进行中</strong>
          <strong v-if="item.checkin == 3 && item.stat == 1">已结束</strong>
          <a v-if="(powers.cancelChildCheckin && item.overstay == 2 && checkins.step != 3 && checkins.stat != 2 && item.payStat == 1 && item.stat != 2)"
            @click="cancleChildOrderBtn(item.checkinInfoId)">取消</a>
        </Row>
      </div>
      <Row v-if="checkins.step != 1" style="margin-bottom:15px">
        <Col>
          <Icon type="md-menu"></Icon> 实际入住：{{ checkins.actualCheckinTime }} -- 实际退房：{{ checkins.actualCheckoutTime
          }}
        </Col>
      </Row>
      <Row v-if="checkins.stat == 2" style="margin-bottom:15px">
        <Col>
          取消时间:{{ checkins.cancelDate }} 取消原因:{{ checkins.cancelReasion }}
        </Col>
      </Row>
      <Row v-if="checkins.stat != 2" style="margin-bottom:15px">
        <Icon type="md-paper-plane"></Icon>
        <span v-if="checkins.stat == 1 && checkins.step == 1"><Tag color="default">等待入住</Tag></span>
        <span v-if="checkins.stat == 1 && checkins.step == 2">入住中</span>
        <span v-if="checkins.stat == 1 && checkins.step == 3 && checkins.actualCheckinTime != null"><Tag
            color="success">已退房</Tag></span>
        <span v-if="checkins.stat == 1 && checkins.step == 3 && checkins.actualCheckinTime == null"><Tag
            color="success">预订未到</Tag></span>
        <span v-if="checkins.stat == 2 || checkins.stat == 3 && !reasionCheck(checkins.cancelReasion)"><Tag
            color="error">已取消</Tag></span>
        <span v-if="checkins.stat == 2 || checkins.stat == 3 && reasionCheck(checkins.cancelReasion)"><Tag
            color="error">已换房</Tag></span>

        <span v-if="checkins.stat == 1 && checkins.step == 1 && checkins.reason == 2">不可办理入住:未支付</span>
        <span v-if="checkins.stat == 1 && checkins.step == 1 && checkins.reason == 3">不可办理入住:可办理入住时间未到</span>
        <span v-if="checkins.stat == 1 && checkins.step == 1 && checkins.reason == 4">不可办理入住:房间清洁中</span>
        <span v-if="checkins.stat == 1 && checkins.step == 1 && checkins.reason == 5">不可办理入住:上一个入住人暂时还没退房</span>
        <span v-if="checkins.stat == 1 && checkins.step == 1 && checkins.reason == 6">不可办理入住:房间未审核</span>
        <span v-if="checkins.stat == 1 && checkins.step == 1 && checkins.reason == 7">不可办理入住:最晚入住时间已过</span>
        <span v-if="checkins.roomCurStat == 2">不可办理入住:房间停用单未结束</span>
        <span style="color:red">*续住会取消延时退房申请若有需求需再次申请</span>
      </Row>
      <Row v-for="(customer, index) in checkins.checkiner" v-if="customer.type != -1" :key="index"
        style="margin-bottom:15px">
        <Col>
          <Icon type="md-person"></Icon>
          <Tag :color="customer.identityStatus == 2 ? 'success' : 'default'">{{ ['未验证', '待审核', '已验证', '审核不通过',
            '未完成'][customer.identityStatus] }}{{ customer.identityStatus == 2 ? (customer.identityType == 1 ? '(大陆)' :
            '(港澳台外)') : '' }}</Tag>
          <Tag color="primary" v-if="checkins.stat == 1 && customer.checkin == 2">已入住</Tag>
          <Tag color="primary" v-if="checkins.stat == 1 && customer.checkin == 1">未入住</Tag>
          <a @click.prevent="lodgerInfoBtn(customer)">{{ customer.name }}_{{ customer.phone }}</a>
          <a v-if="checkins.step != 3" href="" style="color:red"
            @click.prevent="delCustomerBtn(customer.id, customer.infoId)"><Icon type="md-close-circle"></Icon></a>
        </Col>
      </Row>
      <Row>

        <Button v-if="powers.checkinAddUser && checkins.stat == 1 && checkins.step != 3" type="primary"
          @click="addCustomerBtn">添加入住人</Button>
        <Button :disabled="checkins.roomBuildingInfo.isXpms || false"
          v-if="powers.checkin && checkins.stat == 1 && checkins.step != 3 && checkins.reason == 1 && checkinState && checkins.roomCurStat == 0"
          type="primary" @click="checkinBtn">办理入住</Button>
        <!-- 注释在住清洁按钮 -->
        <!-- <a href="#public-modal" ng-if="powers.checkinClean && checkins.stat == 1 && checkins.step == 2" ng-click="checkinCleanEvent(checkins)" data-toggle="modal"  class="badge badge-roundless badge-success">在住清洁</a> -->
        <!-- 换房按钮 -->
        <Button :disabled="checkins.roomBuildingInfo.isXpms || false"
          v-if="powers.changeRoomId && checkins.stat == 1 && checkins.pay && checkins.step != 3 && checkins.source != 6"
          type="warning" @click="changeRoomBtn">换房</Button>

        <Button v-if="powers.orderVerify && checkins.stat == 1 && checkins.step == 2 && checkins.verify == false"
          type="warning" @click="validateChinkinerBtn">身份验证</Button>

        <Button :disabled="checkins.roomBuildingInfo.isXpms || false"
          v-if="powers.overstayCalculationCheckin && checkins.stat == 1 && checkins.pay && checkins.step != 3"
          type="warning" @click="overstayBtn">续住</Button>

        <Button :disabled="checkins.roomBuildingInfo.isXpms || false"
          v-if="powers.checkout && checkins.stat == 1 && isApplyLateCheckOut" type="warning"
          @click="checkoutBtn">立即退房</Button>
        <!-- 有退房权限 && 正常入住单 && 未入住 && 已过入住时间 && 至少有一笔已支付 -->
        <Button :disabled="checkins.roomBuildingInfo.isXpms || false"
          v-if="powers.checkout && checkins.stat == 1 && checkins.step == 1 && checkins.checkinPayStat != 3 && checkins.overCheckinTime"
          type="warning" @click="checkoutBtn">未到店退房</Button>
        <!-- 取消子入住单1，未入住并且没有过入住时间 -->
        <!-- 取消子入住单2，全部未支付才能取消 -->
        <!-- 取消子入住单，提前办理入住不能取消, step 1未入住 2已入住 3已退房-->
        <Button :disabled="checkins.roomBuildingInfo.isXpms || false"
          v-if="powers.cancelCheckin && checkins.stat == 1 && (checkins.checkinPayStat == 3 || (checkins.step != 3 && !checkins.overCheckinTime)) && currentCheckinStep != 2"
          type="error" @click="cancelCurrentOrderBtn">取消入住单</Button>
        <Button v-if="powers.resetPwd && checkins.stat == 1 && checkins.step == 2 && checkins.verify" type="error"
          @click="resetPwdBtn" :loading="resetPsd">重置密码</Button>
        <Button v-if="isLateCheck" type="success"
          @click="lateCheckOut">申请延时退房</Button>
        <Button v-if="isApplyLateCheckOut" type="success"
          @click="netWorkOpen">网络开门</Button>
        <Button v-if="isApplyLateCheckOut" type="success"
          @click="elecOpen">通电重试</Button>
          <!-- 测试用 -->
          <!-- <Button type="success"
          @click="netWorkOpen">网络开门</Button> -->
        <span v-if="checkins.roomBuildingInfo.isXpms || false" style="color:red;font-size:12px;">*
          本入住单需在酒店前台通过XMS/PMS系统进行入住、换房、续住、退房等操作</span>
      </Row>
    </div>
    <div style="marginTop:15px">
      <Tabs style="width:1100px">
        <TabPane label="入住单增值服务" name="valueAddServices">
          <ValueAddServives :otherServiceFeeList="checkins.otherServiceFeeList"></ValueAddServives>
        </TabPane>
        <TabPane label="房费日结" name="payByDay">
          <PayByDay :payInfo="checkins.consumptionContent"></PayByDay>
        </TabPane>
      </Tabs>
    </div>
    <Modal ref="customerModal" v-model="addCustomerModal.display" :loading="true" title="添加入住人"
      @on-ok="addCustomerEvent">
      <Form ref="addCustomerForm" :model="addCustomerModal.data" :rules="addCustomerModal.rules">
        <FormItem label="入住人" :label-width="84">
          <Input v-model="addCustomerModal.data.userName"></Input>
        </FormItem>
        <FormItem label="手机号码" :label-width="84" prop="phone">
          <Input v-model="addCustomerModal.data.phone"></Input>
        </FormItem>
      </Form>
    </Modal>

    <Modal ref="checkinModal" v-model="checkinModal.display" title="代|办理入住" @on-ok="checkinEvent">
      <Form>
        <FormItem label="主入住人" :label-width="84">
          <Select v-model="checkinModal.infoId">
            <Option v-for="item in checkins.checkiner" v-if="item.type != -1" :key="item.id" :value="item.infoId">{{
            item.name }}_{{ item.phone }}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <!-- 延迟退房 -->
    <Modal ref="lateCheckOutModal" :loading="true" width="600" v-model="lateCheckOutModal.display" :okText="confirmText" title="延迟退房" @on-ok="confirmLateCheck">
      <Form ref="LateCheckForm" :model="lateCheckOutModal" :rules="lateCheckOutModal.rules">
        <FormItem label="房号" :label-width="84">{{ checkins.roomNo }}</FormItem>
        <FormItem label=" " :label-width="84"> {{ titleTips }} </FormItem>
        <FormItem label="申请人" prop="phone" :label-width="84">
          <Select v-model="lateCheckOutModal.phone">
            <Option v-for="item in checkins.checkiner" v-if="item.type != -1 && item.checkin != 1" :key="item.id" :value="item.phone">{{
            item.name }}_{{ item.phone }}</Option>
          </Select>
        </FormItem>
        <FormItem label="备注" prop="remark" :label-width="84">
          <Input v-model="lateCheckOutModal.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" @blur="lateCheckOutModal.remark=$event.target.value.trim()"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 延迟退房end -->
    <!-- 网络开门 -->
    <Modal ref="netWorkOpen" :loading="true" width="600" v-model="network.display" @on-ok="confirmNetWork" title="网络开门">
      <Form ref="workOpenForm" :model="network" :rules="network.rules">
        <FormItem label="房号" :label-width="60">{{ checkins.roomNo }}</FormItem>
        <FormItem label="备注" prop="remark" :label-width="60">
          <Input v-model="network.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></Input>
        </FormItem>
      </Form>
      <!-- <Button type="primary" :loading="workLoading" @click="workConfirm">确定</Button> -->
      <!-- <Button @click="network.display = false">取消</Button> -->
    </Modal>
    <!-- 网络开门end -->
    <!-- 通电重试 -->
    <Modal ref="elecOpen" :loading="true" width="600" v-model="elec.display" @on-ok="confirmElec" title="通电重试">
      <Form ref="elecForm" :model="elec" :rules="elec.rules">
        <FormItem label="房号" :label-width="60">{{ checkins.roomNo }}</FormItem>
        <FormItem label="备注" prop="remark" :label-width="60">
          <Input v-model="elec.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 通电重试end -->
    <Modal ref="cancleModal" :loading="true" width="600" v-model="cancleModal.display" title="取消入住单"
      @on-ok="cancleOrder">
      <p style="text-align:center;font-size:14px">
        <Icon type="md-alert" style="color:red"></Icon> 确定取消订单？该操作不可恢复，请谨慎操作
      </p><br>
      <Form ref="cancleModelForm" :model="cancleModal" :rules="cancleModal.rules">
        <FormItem label="取消理由" :label-width="84" prop="remark">
          <Input v-model="cancleModal.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></Input>
        </FormItem>
        <FormItem label="入帐单处理">
          <RadioGroup v-model="cancleModal.cancelRule" @on-change="changeCancleType">
            <Radio label="system">按系统规则取消</Radio>
            <Radio label="artificialSelection">人工选择取消</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="cancleModal.cancelRule === 'system'" label="应退房费" :label-width="100">
          <Input disabled :value="cancleModal.realRefundAmount"></Input>
        </FormItem>
        <FormItem v-if="cancleModal.cancelRule === 'system'" label="应退押金" :label-width="100">
          <Input disabled :value="cancleModal.bargainMoney"></Input>
        </FormItem>
      </Form>
      <Row v-if="cancleModal.cancelRule === 'artificialSelection'">
        <Col span="8">已选择：{{ cancleModal.selectIds.length }}/{{ cancleModal.total }}</Col>
        <Col span="8">退款金额：{{ cancleModal.cancelMoney }}</Col>
        <Col span="8">
          <Page size="small" :total="cancleModal.total" @on-change="changePage"></Page>
        </Col>
      </Row>
      <Table v-if="cancleModal.cancelRule === 'artificialSelection'" :columns="cancleModal.columns"
        :data="cancleModal.content" @on-select-all="selectAll" @on-select="selectRow" @on-select-cancel="cancelRow"
        @on-selection-change="selectAllCancel"></Table>
    </Modal>

    <Modal ref="roomModal" :loading="true" v-model="roomModal.display" title="换房" width="950" @on-ok="changeRoomSub">
      <Row>
        <Col span="12">
          换房日期：{{ dateInfo.beginDate }} - {{ dateInfo.endDate }}
        </Col>
        <Col span="12">
          剩余房费：{{ dateInfo.surplus }}
        </Col>
      </Row><br>
      <Form inline>
        <FormItem label="门店" :label-width="84">
          <Select v-model="select.chainId" style="width:200px" transfer filterable>
            <!-- <Option :value='0'>--请选择--</Option> -->
            <Option v-for="item in hotelList" :key="item.chain_id" :value="item.chain_id">{{ item.chain_name
              }}</Option>
          </Select>
        </FormItem>
        <FormItem label="房型" :label-width="84">
          <Select v-model="select.roomTypeName" style="width:200px" transfer>
            <Option :value='0'>--请选择--</Option>
            <Option v-for="item in roomType" :key="item.code" :value="item.cname">{{ item.cname }}</Option>
          </Select>
        </FormItem>
        <FormItem label="房号" :label-width="84">
          <Input v-model="select.custRoomNo"></Input>
        </FormItem>
        <FormItem label="房名" :label-width="84">
          <Input v-model="select.custRoomName"></Input>
        </FormItem>
        <FormItem label=" " :label-width="84">
          <Button type="primary" @click="queryRoomList">查询</Button>
        </FormItem>
      </Form>
      <Page placement="bottom" show-sizer :total="frontEndPageConfig.count" :current="frontEndPageConfig.page"
        @on-page-size-change="changeFrontEndPagesPageSize" @on-change="changeFrontEndPagesPage"></Page>
      <Table :loading="tableLoading" :columns="roomModal.cloums" :data="frontEndPageConfig.displayList"
        height="300"></Table><br>
      <Row>
        <Col span="12">
          已选择：{{ selectRoom.custRoomName }}
        </Col>
      </Row><br>
      <Row>
        <Col span="12">差价：{{ changeInfo.chargePrice }}</Col>
        <Col span="12">
          <RadioGroup v-model="changeInfo.pay" v-if="changeInfo.chargePrice != 0">
            <Radio :label="1">
              <span>需要{{ changeInfo.chargePrice > 0 ? '补' : '退' }}差价{{ changeInfo.chargePrice > 0 ? '' : '(退款)'
                }}</span>
            </Radio>
            <Radio :label="0">
              <span>不需要{{ changeInfo.chargePrice > 0 ? '补' : '退' }}差价{{ changeInfo.chargePrice > 0 ? '' : '(不退款)'
                }}</span>
            </Radio>
          </RadioGroup>
        </Col>
      </Row><br>
      <Row>
        <Col span="2">
          备注：
        </Col>
        <Col span="10">
          <Input v-model="changeInfo.remark" type="textarea" placeholder="Enter something..."></Input>
        </Col>

        <Col style="color:red;" span="12" class="flex_col_end">
          <span>换房将取消原房的清洁单：</span>
          <span>如需打扫请手动创建清洁单！</span>
          <span>无需打扫请手动将原房置净！</span>
        </Col>
      </Row>
    </Modal>

    <Modal ref="overStayModal" :loading="true" v-model="overModel.display" title="续住" width="800"
      @on-ok="overStaySubBtn">
      <Form ref="overStayForm" :rules="ruleValidate" :model="overInfo">
        <FormItem label="预订人" :label-width="100">
          <Input disabled :value="order.name"></Input>
        </FormItem>
        <FormItem label="预订人手机" :label-width="100">
          <Input disabled :value="order.phone"></Input>
        </FormItem>
        <FormItem label="租房类型" :label-width="100">
          <Input disabled :value="order.rentType == 1 ? '短租' : order.rentType == 2 ? '长租' : '钟点房'"></Input>
        </FormItem>
        <FormItem label="续住时间" :label-width="100" prop="endDate">
          <DatePicker v-model="overInfo.endDate" type="date" :clearable="false" :options="option"
            @on-change="overstayBtn"></DatePicker>
        </FormItem>
        <FormItem label="房间" :label-width="100">
          <Input disabled :value="`${checkins.roomTypeName}_${checkins.roomNo}_${checkins.roomName}`"></Input>
        </FormItem>
        <FormItem label="订单总价" :label-width="100">
          <Input disabled :value="overInfo.price"></Input>
        </FormItem>
        <FormItem label="优惠扣减" :label-width="100">
          <Input disabled :value="overStay.discount"></Input>
        </FormItem>
        <FormItem label="订单应付" :label-width="100">
          <Input disabled :value="overInfo.shouldPay"></Input>
        </FormItem>
        <FormItem label="备注" :label-width="100" prop="remark">
          <Input v-model="overInfo.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></Input>
        </FormItem>
      </Form>
    </Modal>
    <Modal ref="checkoutModal" :loading="true" v-model="checkoutModal.display" title="立即退房" width="600"
      @on-ok="subCheckInfoBtn">
      <p style="text-align:center;font-size:14px">
        <Row v-if="checkins.hasDelayCheckout" style="color:red">当前房间已延时至 {{checkins.infos[0].delayCheckoutTime}} 退房
        </Row>
        <Icon type="md-alert" style="color:red"></Icon>确定立即退房？该操作不可恢复，请谨慎操作
      </p><br>
      <Form ref="checkoutModelForm" :rules="checkoutModal.rule" :model="checkoutModal">
        <FormItem label="备注" :label-width="100" prop="remark">
          <Input v-model="checkoutModal.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"></Input>
        </FormItem>
        <FormItem label="入帐单处理">
          <RadioGroup v-model="checkoutModal.cancelRule" @on-change="changeCancleType">
            <Radio label="system">按系统规则取消</Radio>
            <Radio label="artificialSelection" v-if="!((checkins.stat == 1 && checkins.step == 3) && isApplyLateCheckOut)">人工选择取消</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="checkoutModal.cancelRule === 'system'" label="应退房费" :label-width="100">
          <Input disabled :value="checkoutModal.realRefundAmount"></Input>
        </FormItem>
        <FormItem v-if="checkoutModal.cancelRule === 'system'" label="应退押金" :label-width="100">
          <Input disabled :value="checkoutModal.bargainMoney"></Input>
        </FormItem>
      </Form>
      <Row v-if="checkoutModal.cancelRule === 'artificialSelection'">
        <Col span="8">已选择：{{ checkoutModal.selectIds.length }}/{{ checkoutModal.total }}</Col>
        <Col span="8">退款金额：{{ checkoutModal.cancelMoney }}</Col>
        <Col span="8">
          <Page size="small" :total="checkoutModal.total" @on-change="changePage"></Page>
        </Col>
      </Row>
      <Table v-if="checkoutModal.cancelRule === 'artificialSelection'" :columns="checkoutModal.columns"
        :data="checkoutModal.content" @on-select-all="selectAll" @on-select="selectRow" @on-select-cancel="cancelRow"
        @on-selection-change="selectAllCancel"></Table>
    </Modal>
    <Modal v-model="lodgerModel" title="用户身份信息" width="500">
      <Row>
        <Col span="5">姓名：</Col>
        <Col span="4">{{ lodgerInfo.name }}</Col>
      </Row><br>
      <Row>
        <Col span="5">手机号：</Col>
        <Col span="4">{{ lodgerInfo.mobile }}</Col>
      </Row><br>
      <Row>
        <Col span="5" style="height:25px;line-height:25px">大陆身份：</Col>
        <Col span="19">
          <Tag :color="['error', 'warning', 'success', 'error', 'default'][lodgerInfo.auditStatus]">{{ ['未验证', '待审核',
            '已验证', '审核不通过', '未完成'][lodgerInfo.auditStatus] }}</Tag>
          <span>{{ lodgerInfo.IDCardNo || '-' }}</span>
        </Col>
      </Row><br>
      <Row>
        <Col span="6" style="height:25px;line-height:25px">港澳台/外籍身份：</Col>
        <Col span="18">
          <Tag :color="['error', 'warning', 'success', 'error', 'default'][lodgerInfo.certificateAuditStatus]">{{
            ['未验证', '待审核', '已验证', '审核不通过', '未完成'][lodgerInfo.certificateAuditStatus] }}</Tag>
          <span>{{ lodgerInfo.certCardNo || '-' }}</span>
        </Col>
      </Row><br>
      <!-- <p class="tips">*将身份证放在读卡器上，点击获取身份证信息</p> -->
      <div slot="footer">
        <!-- <Row>
        <Col span="12" class="center">
          <Button type="primary" :disabled="!((lodgerInfo.cardType == 1) && (lodgerInfo.auditStatus==0 || lodgerInfo.auditStatus==3))">读卡器验证身份</Button>
        </Col>
        <Col span="12" class="center"> -->
        <Button @click="lodgerModel = false">关闭</Button>
        <!-- </Col>
      </Row> -->
      </div>
    </Modal>
    <Modal v-model="resetPwdModal.display" title="重置入住单密码" :loading="true" @on-ok="resetPwdEvent"
      @on-cancel="resetPsd = false" ref="resetPwdModal">
      <Form>
        <FormItem label="接收短信手机号" :label-width="115">
          <Input v-model="resetPwdModal.phone"></Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import Moment from "moment";
import ValueAddServives from './value-add-services'
import PayByDay from './pay-by-day'
import { phoneRegular } from '@/utils/regular.js'
import MIXINS from '../../../mixins'
import Utils from "@/utils";
import API from "@/api";
import {STORE_KEY} from "../../../constants"

export default {
  mixins: [MIXINS.FRONT_END_PAGES],
  props: {
    checkinId: {
      type: Number,
      default() {
        return 0
      }
    },
    checkIds: {
      type: Array,
      default() {
        return []
      }
    },
    checkins: {
      type: Object,
      default() {
        return {
          item: ''
        }
      }
    },
    powers: {
      type: Object,
      default() {
        return {
          item: ''
        }
      }
    },
    checkinState: {
      type: Boolean,
      default() {
        return false
      }
    },
    hotelList: {
      type: Array,
      default() {
        return []
      }
    },
    roomType: {
      type: Array,
      default() {
        return []
      }
    },
    roomList: {
      type: Array,
      default() {
        return []
      }
    },
    dateInfo: {
      type: Object,
      default() {
        return {
          beginDate: '',
          endDate: '',
          surplus: '',
          surplusDiscount: ''
        }
      }
    },
    overStay: {
      type: Object,
      default() {
        return {
          item: ""
        }
      }
    },
    order: {
      type: Object,
      default() {
        return {
          item: ""
        }
      }
    },
    checkoutInfo: {},
    lodgerInfo: {},
    unfinishConsumptions: {}
  },
  watch: {
    roomList: function (val) {
      if (val) {
        this.createFrontEndPages(val);
        this.tableLoading = false;
      }
    },
    overStay: function (val) {
      if (val) {
        this.overInfo.endDate = val.endDateTime;
        this.overInfo.price = (val.price / 100).toFixed(2);
        this.overInfo.discount = (val.discount / 100).toFixed(2);
        this.overInfo.shouldPay = (val.shouldPay / 100).toFixed(2);
      }
    },
    checkoutInfo: function (val) {
      if (val) {
        if (this.operateType === 'checkoutModal') {
          this.checkoutModal.realRefundAmount = (val.realRefundAmount / 100).toFixed(2);
          this.checkoutModal.bargainMoney = (val.bargainMoney / 100).toFixed(2);
        } else if (this.operateType === 'cancleModal') {
          this.cancleModal.realRefundAmount = (val.realRefundAmount / 100).toFixed(2);
          this.cancleModal.bargainMoney = (val.bargainMoney / 100).toFixed(2);
        }      
      }
    },
    unfinishConsumptions: function (val) {
      if (val.list) {
        this[this.operateType].content = val.list;
        this[this.operateType].content.forEach((item) => {
          if (this[this.operateType].selectIds.includes(item.ids)) {
            item._checked = true;
          }
        })
        this[this.operateType].page = val.pageNum;
        this[this.operateType].total = val.total;
      }
    },
    checkins: {
      immediate: true,
      handler: function (val) {
        this.overInfo.endDate = Moment(val.checkoutTime).add(1, 'd').format('YYYY-MM-DD')
        // 未退房，延迟退房
        if(val.step === 2 || ( val.hasDelayCheckout && val.delayCheckoutTime && val.delayStatus == 0 && new Date().getTime() < new Date(val.delayCheckoutTime).getTime() )) {
          this.isApplyLateCheckOut = true
        } else { 
          this.isApplyLateCheckOut = false
        }

        // 最后一天的早上6点开始
        if(val.infos.length !== 0) {
          let delayCheckoutTime = val.infos[0].delayCheckoutTime
          // 提前退房最大延迟退房时间是当日
          if(val.actualCheckoutTime){
            delayCheckoutTime = val.actualCheckoutTime.split(' ')[0] + ' ' + val.infos[0].delayCheckoutTime.split(' ')[1]
          }
          const str = delayCheckoutTime.split(' ')[0]
          const time = str + ' 06:00:00'
          // 预退房日-86400000就是最后一个房晚日，日租房，且未过可延迟退房时间
          console.log("chekins==============", time, "===", val.rentType === 1, "====", new Date().getTime() >= new Date(time).getTime() - 86400000, "=====delayCheckoutTime===", delayCheckoutTime, "====",new Date().getTime() < new Date(delayCheckoutTime).getTime())
          if(val.rentType === 1 && new Date().getTime() >= new Date(time).getTime() - 86400000 && new Date().getTime() < new Date(delayCheckoutTime).getTime()){
            this.setInfo()
          } else {
            this.isLateCheck = false
          }
        }
     
        // if (val.infos[0].delayCheckoutTime && new Date().getTime() < new Date(val.infos[0].delayCheckoutTime).getTime()) {
        //     this.setInfo()
        //     // const bol = this.checkIds.some(item=> item.step === 1 || item.step === 3)
        //     // if (bol) {
        //     //   this.isLateCheck = true
        //     // }
        //   } else {
        //     this.isLateCheck = false
        //   }
      }
    },
    checkIds: function (val) {
      if (val) {
        this.currentCheckStep(this.currentCheckinId);
      }
    }
  },
  computed: {
    currentCheckinId: {
      set: function () {
        return this.checkinId
      },
      get: function () {
        return this.checkinId
      },
    }
  },
  data() {
    return {
      workLoading:false,
      titleTips:"",
      confirmText:"",
      isLateCheck: true, //申请延迟退房按钮
      isApplyLateCheckOut: false, //是否申请延迟退房
      resetPsd: false, // 重置密码按钮是否显示loading
      isXpms: true,
      selectRoomId: null,
      childList: false,
      operateType: null,
      resetPwdModal: {
        display: false,
        phone: ''
      },
      select: {
        chainId: "",
        roomTypeName: "",
        custRoomName: "",
        custRoomNo: ""
      },
      addCustomerModal: {
        display: false,
        data: {
          userName: "",
          phone: ""
        },
        rules: {
          phone: [
            { required: true, message: '入住人手机号不能为空' },
            { pattern: /^[1][0-9][0-9]{9}$/, message: '手机号码格式错误' }
          ]
        }
      },
      checkinModal: {
        display: false,
        infoId: ''
      },
      overModel: {
        display: false
      },
      lateCheckOutModal:{
        remark:"",
        phone:"",
        rules:{
          remark: [
            { required: true, message: '必须填写' }
          ],
          phone: [
            { required: true, message: '必须选择' }
          ]
        },
        display:false,
      },
      network: {
        display: false,
        remark:"",
        rules:{
          remark: [
            { required: true, message: '必须填写' }
          ]
        }
      },
      elec: {
        display: false,
        remark:"",
        rules:{
          remark: [
            { required: true, message: '必须填写' }
          ]
        }
      },
      cancleModal: {
        display: false,
        remark: '',
        realRefundAmount: 0,
        bargainMoney: 0,
        cancelMoney: 0,
        cancelRule: null, // 'system',
        rules: {
          remark: [
            { required: true, message: '必须填写' }
          ]
        },
        content: [],
        page: 1,
        pageSize: 10,
        total: 0,
        selectIds: [],
        selectMoney: [],
        columns: [
          {
            title: '房费日期',
            align: 'center',
            width: 145,
            key: 'curDate'
          },
          {
            title: '房费原价',
            align: 'center',
            width: 145,
            key: 'price',
            render: (h, param) => {
              return h('span', {}, (param.row.price / 100).toFixed(2))
            }
          },
          {
            title: '房费应付',
            align: 'center',
            width: 145,
            render: (h, param) => {
              return h('span', {}, (param.row.realPrice / 100).toFixed(2))
            }
          },
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
        ]
      },
      roomModal: {
        display: false,
        cloums: [
          {
            title: '操作',
            align: 'center',
            fixed: 'left',
            width: 100,
            render: (h, param) => {
              return h('Button', {
                props: {
                  type: param.row.roomId === this.selectRoomId ? 'error' : 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.changeInfo.pay = "";
                    if (this.selectRoomId === param.row.roomId) {
                      this.selectRoomId = null
                      this.selectRoom = {};
                      this.changeInfo.chargePrice = "";
                      this.changeInfo.roomId = "";
                    } else {
                      this.selectRoom = param.row;
                      this.selectRoomId = param.row.roomId;
                      this.changeCurrentRoom(param.row)
                    }
                  }
                }
              }, param.row.roomId === this.selectRoomId ? '取消' : '选择')
            }
          },
          {
            title: '房号',
            align: 'center',
            width: 200,
            sortable: true,
            key: 'custRoomNo',
            fixed: 'left',
          },
          {
            title: '价格',
            align: 'center',
            width: 100,
            sortable: true,
            fixed: 'left',
            key: 'price',
            render: (h, param) => {
              return h('div', {}, (param.row.price / 100).toFixed(2))
            }
          },
          {
            title: '当前状态',
            align: 'center',
            width: 150,
            sortable: true,
            key: 'chainType',
            render: (h, param) => {
              const roomStat = ["", "干净房", "脏房", "已入住", "停用", "维修"]
              return h('span', {}, roomStat[param.row.stat])
            }
          },
          {
            title: '房间展示名',
            align: 'center',
            width: 250,
            sortable: true,
            key: 'custRoomName'
          },
          {
            title: '房型',
            align: 'center',
            width: 100,
            sortable: true,
            key: 'roomTypeName'
          },
          {
            title: '所属门店',
            align: 'center',
            width: 250,
            sortable: true,
            key: 'chainName'
          },
          {
            title: '所属楼宇',
            align: 'center',
            width: 250,
            sortable: true,
            key: 'buildingName'
          },
        ]
      },
      checkoutModal: {
        display: false,
        cancelRule: null, // 'system',
        rule: {
          remark: [
            { required: true, message: '请填写备注', trigger: 'blur' }
          ]
        },
        content: [],
        page: 1,
        pageSize: 10,
        total: 0,
        selectIds: [],
        selectMoney: [],
        columns: [
          {
            title: '房费日期',
            align: 'center',
            width: 145,
            key: 'curDate'
          },
          {
            title: '房费原价',
            align: 'center',
            width: 145,
            key: 'price',
            render: (h, param) => {
              return h('span', {}, (param.row.price / 100).toFixed(2))
            }
          },
          {
            title: '房费应付',
            align: 'center',
            width: 145,
            key: 'realPrice',
            render: (h, param) => {
              return h('span', {}, (param.row.realPrice / 100).toFixed(2))
            }
          },
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },
        ],
        realRefundAmount: 0,
        bargainMoney: 0,
        cancelMoney: 0,
        remark: ''
      },
    
      selectRoom: {},
      tableLoading: false,
      changeInfo: {
        pay: 1,
        chargePrice: '',
        remark: '',
        roomId: ''
      },
      ruleValidate: {
        // endDate: [
        //   {required: true, message: '请选择续住日期', trigger: 'change'}
        // ],
        remark: [
          { required: true, message: '请填写备注', trigger: 'blur' }
        ],
      },
      overInfo: {
        endDate: '',
        checkinId: '',
        userId: '',
        rentType: '',
        source: 84,
        price: '',
        remark: ''
      },
      option: {
        disabledDate: (date) => {
          return date && date.valueOf() < Moment(this.overStay.beginDateTime).subtract(1, 'days');
        }
      },
      lodgerModel: false,
      currentCheckinStep: '', // 当前入住单的入住状态值
    }
  },
  mounted() {
    this.currentCheckStep(this.currentCheckinId)
    
  },
  methods: {
    setInfo() { 
      this.isLateCheck = true
      // if(this.checkins.step === 2 || this.checkins.step === 3) {
      //   this.isLateCheck = true
      // } else {
      //   this.isLateCheck = false
      // }
   
    },
    // 网络开门
    netWorkOpen(){
      this.network.display = true
    },// 网络开门
    elecOpen(){
      this.elec.display = true
    },
    // 保存当前入住单的入住状态值
    currentCheckStep(checkinId) {
      if (this.checkIds && this.checkIds.length) {
        this.checkIds.map(item => {
          if (checkinId == item.checkinId) {
            this.currentCheckinStep = item.step
          }
        })
      }
    },
    changeCheckOrder(checkinId) {
      this.currentCheckinId = checkinId;
      this.$emit('changeCheckinId', checkinId)
      this.currentCheckStep(checkinId)
    },
    reasionCheck(reason) {
      const reg = new RegExp("^" + "换房操作，取消该子入住单");
      return reg.test(reason);
    },
    
    confirmNetWork() {
      if (!this.checkHasPermission('oms_lock_openRoomLock.do')) {
        this.$refs.netWorkOpen.buttonLoading = false;
        return;
      }
      this.$refs.netWorkOpen.buttonLoading = false;
      this.$refs.workOpenForm.validate((valid) => {
        if(valid){
          var username = localStorage.getItem('vue-username');
            var params = {
                handlerName: username,
                openType: '1',
                orderNo:  this.order.orderNo,
                remark: this.network.remark,
                roomId:  this.checkins.roomId,
                type: '3'
            }
            var token = localStorage.getItem('vue-token');
            var env = Utils.findFromLocalStorage("env", "dev");
          
            API.omsAPI[env].order.omsRemoteOpenDoor(params, token).then((res) => {
                var data = res.data;
                if (data.retCode && data.retCode !== 21020000 && data.retCode !== 200) {
                  this.$Notice.error({
                    title:data.msg
                  });
                } else {
                  this.$Notice.success("网络开门成功")
                }
            })
        }
      })
          
    },
    checkHasPermission( name ) {
      if ( !Utils.hasPermission( name ) ) {
        this.$Notice.error( {
          title: Utils.getFromStore( STORE_KEY.STORE_KEY_NOT_PERMISSION_TIPS )
        } );

        return false;
      }
      return true;
    },
    confirmElec() {
      if (!this.checkHasPermission('oms_lock_openRoomLock.do')) {
        this.$refs.elecOpen.buttonLoading = false;
        return;
      }
      this.$refs.elecOpen.buttonLoading = false;
      this.$refs.elecForm.validate((valid) => { 
        if(valid){
          var username = localStorage.getItem('vue-username');
            var params = {
                orderNo:  this.order.orderNo,
                checkinId: this.checkins.checkinId,
                remark: this.elec.remark,
                roomId:  this.checkins.roomId,
                operator:'【OMS】' + username,
                powerStatus: '1',
                statusType: 3
            }
            var env = Utils.findFromLocalStorage("env", "dev");
            API.omsAPI[env].clientServer.updateHotelRoomState(params, {
              'isForm': true,
              'x-ca-stage': Utils.aliHeaderEnv(env), 
              'Authorization': Utils.findFromLocalStorage("Author-token"),
            }).then((res) => {
                var data = res.data;
                if (data.retCode && data.retCode !== 21020000 && data.retCode !== 200) {
                  this.$Notice.error({
                    title:data.msg
                  });
                } else {
                  this.$Notice.success({title:"操作成功"})
                  this.elec.display = false;
                }
            })
        }
      })
          
    },
    confirmLateCheck() {
      if (!this.checkHasPermission('addDelayOrder')) {
        this.$refs.lateCheckOutModal.buttonLoading = false;
        return;
      }
      if (this.checkoutInfo.hasDelayCheckout) {
        this.$Notice.error({
          title: `当前房间已申请过延时至\n  ${this.checkins.infos[0].delayCheckoutTime}  退房`
        })
        return
      }
      this.$refs.lateCheckOutModal.buttonLoading = false;
      this.$refs.LateCheckForm.validate((valid) => {
        if(valid){
          this.$emit("alppyLateCheckOut", {remark: this.lateCheckOutModal.remark, phone: this.lateCheckOutModal.phone})
          this.lateCheckOutModal.display = false;
        }
      })
    },
    lateCheckOut() {
      if (this.checkins.hasDelayCheckout) {
        this.$Modal.info({
          title: "延退提醒",
          content: `当前房间已申请过延时至\r\n  ${this.checkins.infos[0].delayCheckoutTime}  退房`,
          okText: "知道了"
        })
        return
      }
      // 退房状态下
      if (this.checkins.stat == 1 && this.checkins.step == 3) {
        this.titleTips = `当前房间优惠至 ${this.checkins.infos[0].delayCheckoutTime} 退房`
        this.confirmText = '确定申请'
      } else {
        this.titleTips = `当前房间申请优惠至  ${this.checkins.infos[0].delayCheckoutTime}  退房\r\n续住后需再次申请延退优惠`
        this.confirmText = '申请延退'
      }
      const defaultCheckiner = (this.checkins.checkiner.filter((item) => {
        return item.type != -1 && item.checkin != 1;
      }))
      if (defaultCheckiner.length < 1) {
        this.$Modal.info({
          title: "延退提醒",
          content: `当前房间无有效入住人，不可申请延迟退房`,
          okText: "知道了"
        })
        return
      }
      this.lateCheckOutModal.phone = defaultCheckiner[0].phone
      this.lateCheckOutModal.display = true; 
    },
    resetPwdBtn() {
      this.resetPsd = true
      this.resetPwdModal.display = true
    },
    resetPwdEvent() {
      this.$refs.resetPwdModal.buttonLoading = false;
      let phone = this.resetPwdModal.phone;
      if (!phoneRegular.test(phone)) {
        this.$Notice.error({
          title: '手机号码格式有误'
        });
        return
      }
      this.$emit('resetPwdEvent', {
        phone,
      });
      this.resetPwdModal.phone = '';
      this.resetPwdModal.display = false;
    },
    validateChinkinerBtn() {
      this.$Modal.confirm({
        title: '消息提醒',
        content: '<p>确定入住单通过验证吗？</p><p>请谨慎操作!</p>',
        onOk: () => {
          this.$emit('validateChinkiner')
        }
      })
    },
    delCustomerBtn(cusId, infoId) {
      this.$Modal.confirm({
        title: '消息提醒',
        content: '确认删除入住人吗？',
        onOk: () => {
          this.$emit('delCustomer', { cusId: cusId, infoId })
        }
      })
    },
    addCustomerBtn() {
      this.addCustomerModal.display = true;
    },
    addCustomerEvent() {
      this.$refs.customerModal.buttonLoading = false;
      this.$refs.addCustomerForm.validate((valid) => {
        if (valid) {
          this.$emit('addCustomer', {
            checkinId: this.currentCheckinId,
            userName: this.addCustomerModal.data.userName,
            phone: this.addCustomerModal.data.phone
          });
          this.addCustomerModal.display = false;
        }
      });
    },
    checkinBtn() {
      this.checkinModal.display = true;
      this.checkinModal.infoId = (this.checkins.checkiner.filter((item) => {
        return item.type != -1;
      }))[0].infoId
    },
    checkinEvent() {
      this.$emit('checkin', { infoId: this.checkinModal.infoId, checkinId: this.currentCheckinId });
    },
    overstayBtn() {
      if (this.checkins.checkiner.length < 1) {
        this.$Notice.error({
          title: '请添加一个入住人后，再尝试办理入住'
        });
        return;
      } else {
        this.$emit('overStayCalculation', Moment(this.overInfo.endDate).format('YYYY-MM-DD'));
      }
      this.overModel.display = true;
    },
    overStaySubBtn() {
      this.$refs.overStayModal.buttonLoading = false;
      this.$refs.overStayForm.validate((valid) => {
        if (valid) {
          let param = {
            checkinId: this.currentCheckinId,
            endDate: Moment(this.overInfo.endDate).format('YYYY-MM-DD'),
            userId: '',
            source: this.overInfo.source,
            rentType: this.order.rentType,
            price: this.overInfo.price,
            remark: this.overInfo.remark,
          }
          this.$emit('overStaySub', param);
          this.overModel.display = false;
        }
      })
    },
    cancleChildOrderBtn(checkinInfoId) { //取消续子入住单
      this.$Modal.confirm({
        title: '消息提醒',
        content: '确认取消续住单吗？',
        onOk: () => {
          this.$emit('cancleChildOrder', { infoId: checkinInfoId, checkinId: this.currentCheckinId })
        }
      })
    },
    cancleOrder() {
      this.$refs.cancleModal.buttonLoading = false;
      this.$refs.cancleModelForm.validate((valid) => {
        if (valid) {
          // if(this.cancleModal.cancelRule == 'artificialSelection' && this.cancleModal.selectIds.length===0){
          //   this.$Notice.error({
          //     title: '请选择要取消的入住单'
          //   })
          //   return
          // }
          this.$emit('cancleOrder', {
            remark: this.cancleModal.remark,
            checkinId: this.currentCheckinId,
            cancelRule: this.cancleModal.cancelRule,
            listConsumptionId: this.cancleModal.cancelRule === 'artificialSelection' ? this.cancleModal.selectIds.join(",") : ''
          });
          this.cancleModal.display = false;
        }
      })
    },
    changeRoomBtn() {
      this.$emit('qureyRoomInfo');
      this.selectRoom = {};
      this.select = {
        chainId: Number(this.checkins.roomBuildingInfo.chainName.split('_')[0]),
        roomTypeName: "",
        custRoomName: "",
        custRoomNo: ""
      },
        this.changeInfo = {
          pay: '',
          chargePrice: '',
          remark: '',
          roomId: ''
        },
        this.createFrontEndPages([]);
      this.roomModal.display = true;
    },
    queryRoomList() {
      this.tableLoading = true;
      this.frontEndPagesReset();
      let param = Object.assign({}, this.select);
      (param.chainId == 0) && (param.chainId = null);
      (param.roomTypeName == 0) && (param.roomTypeName = null);
      this.$emit('qureyRoomList', param);
    },
    changeCurrentRoom(currentRow) {
      let chargePrice = (currentRow.price / 100) - this.dateInfo.surplus
      let banlence = 0
      if (chargePrice < 0) {
        banlence = (currentRow.price / 100) - this.dateInfo.surplus;
      } else if (chargePrice > 0) {
        if (!this.dateInfo.surplusDiscount) {
          banlence = (currentRow.price / 100) - this.dateInfo.surplus
        } else {
          let newCharge = (currentRow.price / 100) - this.dateInfo.surplus - this.dateInfo.surplusDiscount
          if (newCharge <= 0) {
            banlence = 0
          } else {
            banlence = (currentRow.price / 100) - this.dateInfo.surplus - this.dateInfo.surplusDiscount
          }
        }
      }
      // let banlence = (currentRow.price/100) - this.dateInfo.surplus - this.dateInfo.surplusDiscount;
      this.changeInfo.chargePrice = banlence.toFixed(2);
      this.changeInfo.roomId = currentRow.roomId
      // this.$emit('queryDiffPrice',currentRow.roomId)
    },
    changeRoomSub() {
      this.$refs.roomModal.buttonLoading = false;
      if (this.changeInfo.roomId === '') {
        this.$Notice.error({
          title: '请选择更换房间'
        });
        return
      }
      if (this.changeInfo.pay === '' && this.changeInfo.chargePrice != 0) {
        this.$Notice.error({
          title: '请选择是否需要补差/退款'
        });
        return
      }
      if (!this.changeInfo.remark) {
        this.$Notice.error({
          title: '请填写备注信息'
        });
        return
      }
      let spreadText = ''
      if (this.changeInfo.chargePrice != 0) {
        spreadText = `【${this.changeInfo.pay === 1 ? '需要' : '不需要'}${this.changeInfo.chargePrice > 0 ? '补' : '退'}差价${this.changeInfo.chargePrice > 0 ? '' : (this.changeInfo.pay === 1 ? '(退款)' : '(不退款)')}】`
      } else {
        spreadText = '【换房无差价】'
      }
      this.roomModal.display = false;
      this.changeInfo.checkinId = this.currentCheckinId;
      this.$emit('subChangeRoom', {
        needPayBalance: Number(this.changeInfo.pay),
        checkinId: this.changeInfo.checkinId,
        roomId: this.changeInfo.roomId,
        remark: spreadText + this.changeInfo.remark
      });
      this.select = {
        chainId: "",
        roomTypeName: "",
        custRoomName: "",
        custRoomNo: ""
      }
      this.changeInfo = {
        pay: '',
        chargePrice: '',
        remark: '',
        roomId: ''
      }
      this.selectRoom = {};
    },
    checkoutBtn() {
      this.checkoutModal.display = true
      this.checkoutModal.selectIds = [];
      this.checkoutModal.cancelRule = 'system';
      this.checkoutModal.cancelMoney = 0;
      this.checkoutModal.selectMoney = [];
      this.operateType = 'checkoutModal';
      this.$emit('getCheckoutInfo', this.currentCheckinId);
    },
    cancelCurrentOrderBtn() {
      this.cancleModal.display = true
      this.cancleModal.selectIds = [];
      this.operateType = 'cancleModal';
      this.cancleModal.cancelRule = 'system';
      this.cancleModal.cancelMoney = 0;
      this.cancleModal.selectMoney = [];
      this.$emit('getCheckoutInfo', this.currentCheckinId);
    },
    subCheckInfoBtn() {
      this.$refs.checkoutModal.buttonLoading = false;
      this.$refs.checkoutModelForm.validate((valid) => {
        if (valid) {
          // if(this.checkoutModal.cancelRule === 'artificialSelection' && this.checkoutModal.selectIds.length===0){
          //   this.$Notice.error({
          //     title: '请选择要取消的入住单'
          //   })
          //   return
          // }
          var remark_prefix = '';
          if(this.checkins.stat == 1 && this.checkins.step == 1 && this.checkins.checkinPayStat != 3){
            remark_prefix =  '【预订未到】'
          }
          let param = {
            checkinId: this.currentCheckinId,
            cancelRule: this.checkoutModal.cancelRule,
            listConsumptionId: this.checkoutModal.cancelRule == 'artificialSelection' ? this.checkoutModal.selectIds.join(",") : '',
            realRefundAmount: this.checkoutModal.cancelRule == 'artificialSelection' ? this.checkoutModal.cancelMoney * 100 : this.checkoutModal.realRefundAmount * 100,
            realBargainMoney: this.checkoutModal.bargainMoney * 100,
            remark: remark_prefix + this.checkoutModal.remark
          }
          this.$emit('subCheckout', param);
          this.checkoutModal.display = false;
        }
      })
    },
    lodgerInfoBtn(customer) {
      this.lodgerInfo = {}
      this.$emit('getLodgerInfo', {
        mobile: customer.phone,
        lodgerId: customer.userId
      })
      this.lodgerModel = true;
    },
    changeCancleType(val) {
      if (val === 'system') {
        this.$emit('getCheckoutInfo', this.currentCheckinId);
      } else if (val === 'artificialSelection') {
        this.$emit('getUnfinishConsumptions', {
          page: 1,
          pageSize: 10
        })
      }
    },
    changePage(page) {
      this.$emit('getUnfinishConsumptions', {
        page: page,
        pageSize: 10
      })
    },
    selectAllCancel(selection) {
      if (selection.length === 0) {
        this[this.operateType].content.forEach((item) => {
          let index = this[this.operateType].selectIds.indexOf(item.ids);
          if (index !== -1) {
            this[this.operateType].selectIds.splice(index, 1);
            this[this.operateType].selectMoney.splice(index, 1);
          }
        })
      }
      this.computedMoney()
    },
    selectAll(selection) {
      if (selection.length !== 0) {
        selection.forEach((item) => {
          if (!this[this.operateType].selectIds.includes(item.ids)) {
            this[this.operateType].selectIds.push(item.ids);
            this[this.operateType].selectMoney.push(item.realPrice);
          }
        })
      }
      this.computedMoney()
    },
    selectRow(selection, row) {
      this[this.operateType].selectIds.push(row.ids);
      this[this.operateType].selectMoney.push(row.realPrice);
      this.computedMoney()
    },
    cancelRow(selection, row) {
      let index = this[this.operateType].selectIds.indexOf(row.ids);
      this[this.operateType].selectIds.splice(index, 1);
      this[this.operateType].selectMoney.splice(index, 1);
      this.computedMoney()
    },
    computedMoney() {
      let totalMoney = 0;
      this[this.operateType].selectMoney.forEach((item) => {
        totalMoney += item;
      })
      this[this.operateType].cancelMoney = (totalMoney / 100).toFixed(2);
    }
    // calcPrice(date) {
    //   let basicDate = Moment(this.overStay.beginDateTime).format('YYYY-MM-DD');
    //   let days = (Moment(date) - Moment(basicDate))/86400000;
    //   this.overInfo.price = ((this.overStay.price/100).toFixed(2))*days;
    //   this.overInfo.shouldPay = ((this.overStay.price/100).toFixed(2))*days - (this.overStay.discount/100).toFixed(2);
    // }
  },
  components: {
    ValueAddServives,
    PayByDay
  }
}
</script>

<style lang="scss" scoped>
.bold {
  font-weight: 900
}

.center {
  text-align: center;

  button {
    width: 200px;
  }
}

.tips {
  color: red;
  text-align: center
}

.flex_col_end {
  display: flex;
  flex-direction: column;
  font-weight: 800;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order_detail/check-list.vue